// import React, { useState, useEffect, useRef } from 'react'; // Added useRef

// import apiCall from '../helper/apiCall';
// import { toast } from 'react-toastify';
// import Spinner from './Spinner'; 
// import ShipmentModal from './ShipmentModal';
// import CancellationModal from './CancellationModal';
// import PrintModal from './PrintModal';
// import usePrint from './usePrint';
// import ShippingLabel from './ShippingLabel';
// import ImageCarouselModal from './ImageCarouselModal';
// import logo from '../assets/logo2.jpg';
// import OrderInvoice from './OrderInvoice';
// const OrderConfirmation = () => {
//     const BASE_URL = "https://www.kanthasri.com";
//     const [orderNumber, setOrderNumber] = useState('');
//     const [orderData, setOrderData] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [accepting, setAccepting] = useState({});
//     const [error, setError] = useState(null);
//     const [showShipmentModal, setShowShipmentModal] = useState(false);
//     const [selectedShipment, setSelectedShipment] = useState(null);
//     const [showCancellationModal, setShowCancellationModal] = useState(false);
//     const [itemToReject, setItemToReject] = useState(null);
//     const [showPrintModal, setShowPrintModal] = useState(false);
//     const [shippingLabelInfo, setShippingLabelInfo] = useState(null);
//     const [showCarousel, setShowCarousel] = useState(false);
//     const [carouselImages, setCarouselImages] = useState([]);
//     // Added for Barcode
//     const inputRef = useRef(null);
//     const labelRef = useRef(null);
//     const invoiceRef = useRef(null); // 2. Create a Ref for the Invoice
//     // Added for Barcode (focuses input on load)
//     useEffect(() => {
//         if (inputRef.current) {
//             inputRef.current.focus();
//         }
//     }, []);

//     // Added for Barcode (detects scanner "Enter")
//     const handleKeyDown = (e) => {
//         if (e.key === 'Enter') {
//             handleSearch();
//         }
//     };

//     const handlePrintInvoiceTrigger = usePrint(invoiceRef, 'Order Invoice');
    
//     const handlePrintInvoice = () => {
//         if (!orderData) return;
//         setTimeout(() => {
//             handlePrintInvoiceTrigger();
//         }, 150);
//     };
//     const handleReject = (orderItemId) => {
//         setItemToReject(orderItemId);
//         setShowCancellationModal(true);
//     };

//     const handleCloseCancellationModal = () => {
//         setShowCancellationModal(false);
//         setItemToReject(null);
//     };

//     const handleConfirmRejection = async (val) => {
//         handleCloseCancellationModal()    
//     };

//     const handleInitiateShipment = (shipmentId) => {
//         const shipmentToEdit = orderData.shipments.find(s => s.shipment_id === shipmentId);
//         setSelectedShipment(shipmentToEdit);

//         setShowShipmentModal(true);
//     };

//     const handleCloseShipmentModal = () => {
//         setShowShipmentModal(false);
//         setSelectedShipment(null);
//     };

//     const handleUpdateShipment = async (val) => {
          
//             await handleSearch();
        
//         handleCloseShipmentModal();
//     };


//     const handleSearch = async () => {
//         if (!orderNumber) {
//             setError('Please enter an order number.');
//             return;
//         }

//         setLoading(true);
//         setError(null);
//         setOrderData(null);

//         try {
//             const payload = { order_number: orderNumber };
//             const response = await apiCall("getOrderDetail", payload);
//             if (response.success) {
//                 setOrderData(response.data);
//             } else {
//                 setError(response.message);
//             }
//         } catch (err) {
//             setError('Failed to fetch order details. Please try again.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleAccept = async (orderItemId, orderNumber) => {
//         console.log('orderNumber:',orderNumber);
//         const isConfirmed = window.confirm("Are you sure you want to accept this order item?");
//         if (isConfirmed) {
//             setAccepting(prev => ({ ...prev, [orderItemId]: true }));
//             try {
//                 const payload = { order_item_id: orderItemId, order_number: orderNumber };
//                 const response = await apiCall("acceptOrderItem", payload);
//                 if (response.success) {
//                     toast.success(response?.message || 'Order item accepted successfully.');
//                     await handleSearch();
//                 } else {
//                     toast.error(response?.message || 'Failed to accept order item.');
//                 }
//             } catch (err) {
//                 toast.error('Failed to accept order item. Please try again.');
//             } finally {
//                 setAccepting(prev => ({ ...prev, [orderItemId]: false }));
//             }
//         }
//     };

// const handlePrint = usePrint(labelRef, 'Shipping Label Order');
//     const handleGenerateLabel = (shipmentId) => {
//         const shipmentToGenerateLabel = orderData.shipments.find(s => s.shipment_id === shipmentId);
//         setShippingLabelInfo(shipmentToGenerateLabel);
//         setTimeout(() => {
//         handlePrint();
//     }, 150);
//     };

//     const handleImageClick = (imageObjects) => {
//     if (imageObjects && imageObjects.length > 0) {
//         // Map the objects to an array of full URLs using the 'main' or 'zoom' key
//         const imageUrls = imageObjects.map(img => `${BASE_URL}${img.main}`);
//         setCarouselImages(imageUrls);
//         setShowCarousel(true);
//     }
// };

//     const handleClosePrintModal = () => {
//         setShowPrintModal(false);
//         setSelectedShipment(null);
//     };

//     const renderOrderDetails = () => {
//         if (!orderData) return null;

//         return (
//             <div className="mt-8 pt-8 border-t-2 border-gray-200">
//                 <div className="flex flex-col md:flex-row md:space-x-8">
//                     {/* <div className="flex-1">
                        
//                         <h2 className="text-xl font-bold mb-2 text-gray-800">Order Details</h2>
//                         <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-6">
//                             <p><strong>Order Number:</strong> {orderData.order_number}</p>
//                             <p><strong>Order Date:</strong> {new Date(orderData.order_date).toLocaleDateString()}</p>
//                             <p><strong>Total Amount:</strong> {orderData.final_amount_INR}</p>
//                             <p><strong>Payment Method:</strong> {orderData.payment_method_name}</p>
//                         </div>
//                     </div> */}
//                     <div className="flex-1">
//                         <div className="flex justify-between items-center mb-2">
//                             <h2 className="text-xl font-bold text-gray-800">Order Details</h2>
//                             {/* 4. Add the Print Invoice Button next to Order Details */}
//                             <button
//                                 onClick={handlePrintInvoice}
//                                 className="bg-gray-800 text-white text-xs px-3 py-1 rounded hover:bg-black transition-colors flex items-center gap-2"
//                             >
//                             Print Invoice
//                             </button>
//                         </div>
//                         <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-6">
//                             <p><strong>Order Number:</strong> {orderData.order_number}</p>
//                             <p><strong>Order Date:</strong> {new Date(orderData.order_date).toLocaleDateString()}</p>
//                             <p><strong>Total Amount:</strong> {orderData.final_amount_INR}</p>
//                             <p><strong>Payment Method:</strong> {orderData.payment_method_name}</p>
//                         </div>
//                     </div>
//                     <div className="flex-1 mt-6 md:mt-0">
//                         <h3 className="text-xl font-semibold mb-2 text-gray-800">Shipping Address</h3>
//                         <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-6">
//                             <p>{orderData.shippingAddress.shipping_full_name}</p>
//                             <p>{orderData.shippingAddress.shipping_address_line1}, {orderData.shippingAddress.shipping_address_line2}</p>
//                             <p>{orderData.shippingAddress.shipping_city}, {orderData.shippingAddress.shipping_state_name}, {orderData.shippingAddress.shipping_pincode}</p>
//                             <p>Mobile: {orderData.shippingAddress.shipping_mobile_no}</p>
//                         </div>
//                     </div>
//                 </div>
//                 <h3 className="text-xl font-semibold mb-4 mt-6 text-gray-800">Order Items</h3>
//                 <div className="space-y-6">
//                     {orderData.shipments.map((shipment) => (
//                         <div key={shipment.shipment_id} className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
//                             <div className="flex justify-between items-center">
//                                 <div>
//                                     <h4 className="text-lg font-bold mb-1 text-gray-800">Shipment #{shipment.shipment_id}</h4>
//                                     <p className="mb-4 text-sm text-gray-500"><strong>Status:</strong> {shipment.shipping_status_description}</p>
//                                 </div>
//                                 <button
//                                     onClick={() => handleInitiateShipment(shipment.shipment_id)}
//                                     disabled = {!shipment.shipment_enabled}
//                                     className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
//                                 >
//                                     Update Shipment
//                                 </button>
//                                 <button
//                                         onClick={() => handleGenerateLabel(shipment.shipment_id)}
//                                         className="bg-purple-600 text-white px-4 py-2 rounded-md hover:bg-purple-700 transition-colors"
//                                     >
//                                         Generate Label
//                                     </button>
//                             </div>
//                             <div className="overflow-x-auto">
//                                 <table className="min-w-full divide-y divide-gray-200">
//                                     <thead className="bg-gray-50">
//                                         <tr>
//                                             <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Image</th>
//                                             <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product Name</th>
//                                             <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Order Quantity</th>
//                                             <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stock Quantity</th>
//                                             <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
//                                             <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody className="bg-white divide-y divide-gray-200">
//                                         {shipment.items.map((item) => (
//                                             <tr key={item.order_item_id}>
//                                                 {/* <td className="px-6 py-4 whitespace-nowrap">
//                                                     {item.product_item_images && item.product_item_images.length > 0 && (
//                                                         <img src={item.product_item_images[0]} alt={item.product_name} className="h-20 w-20 object-cover rounded-md" />
//                                                     )}
//                                                 </td> */}

//                                                 <td className="px-6 py-4 whitespace-nowrap cursor-pointer" onClick={() => handleImageClick(item.product_item_images)}>
//                                                 {item.product_item_images && item.product_item_images.length > 0 && (
//                                                     <img
//                                                         // Access the 'main' property of the first object
//                                                         src={`${BASE_URL}${item.product_item_images[0].grid}`}
//                                                         alt={`Variant ${item.order_item_id}`}
//                                                         className="h-12 w-12 rounded-md object-cover border border-gray-200"
//                                                     />
//                                                 )}
//                                             </td>
//                                                 <td className="px-6 py-4 whitespace-nowrap">
//                                                     <div className="text-sm font-medium text-gray-900">{item.product_name}</div>
//                                                     <div className="text-xs text-gray-500">Color: {item.color_name}, Size: {item.size_name}</div>
//                                                 </td>
//                                                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.quantity}</td>
//                                                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.product_item_stock_qty}</td>
//                                                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.final_amount_INR}</td>
//                                                 <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                                                     <button
//                                                         onClick={() => handleAccept(item.order_item_id, item.order_number)}
//                                                         disabled={accepting[item.order_item_id] || item.order_item_status_id === 2}
//                                                         className={`px-4 py-2 rounded-md transition-colors mr-2 ${accepting[item.order_item_id] || item.order_item_status_id === 2 ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 text-white hover:bg-green-600'}`}
//                                                     >
//                                                         {accepting[item.order_item_id] ? <Spinner /> : 'Accept'}
//                                                     </button>
//                                                     <button
//                                                        disabled={item.cancelled}
//                                                         onClick={() => handleReject(item.order_item_id)}
//                                                         className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition-colors"
//                                                     >
//                                                         Reject
//                                                     </button>
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 <ImageCarouselModal show={showCarousel} onClose={() => setShowCarousel(false)} images={carouselImages} />


//                 <ShipmentModal
//                     showModal={showShipmentModal}
//                     onClose={handleCloseShipmentModal}
//                     onUpdate={handleUpdateShipment}
//                     shipmentData={selectedShipment}
//                 />

//                 <CancellationModal
//                     showModal={showCancellationModal}
//                     onClose={handleCloseCancellationModal}
//                     onConfirm={handleConfirmRejection}
//                     orderItemId={itemToReject}
//                     orderData={orderData}
//                 />
//                 <div style={{ display: 'none' }}>
//     {shippingLabelInfo && (
//         <ShippingLabel 
//             ref={labelRef} 
//             orderDetail={shippingLabelInfo.orderDetail} 
//             shippingDetail={shippingLabelInfo.shippingDetail} 
//         />
//     )}

//     {/* Thermal Invoice with Logo Passed as Prop */}
//                     {orderData && (
//                         <OrderInvoice 
//                             ref={invoiceRef} 
//                             orderData={orderData} 
//                             logo={logo} // Passing the logo here
//                         />
//                     )}
// </div>
//             </div>
            
//         );
//     };

//     return (
//         <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
//             <div className="mx-auto bg-white">
//                 <div className="flex flex-col sm:flex-row items-center sm:items-start justify-between sm:space-x-4 mb-8">
//                     <h1 className="text-2xl font-bold mb-4 sm:mb-0 text-gray-800 text-left">Order Details</h1>
//                     <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4">
//                         <input
//                             ref={inputRef}
//                             type="text"
//                             placeholder="Enter Order Number"
//                             value={orderNumber}
//                             onChange={(e) => setOrderNumber(e.target.value)}
//                             onKeyDown={handleKeyDown}
//                             className="flex-1 min-w-0 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
//                         />
//                         <button
//                             onClick={handleSearch}
//                             disabled={loading}
//                             className="w-full sm:w-auto px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                         >
//                             {loading ? <Spinner /> : 'Search'}
//                         </button>
//                     </div>
//                 </div>
//                 {error && <p className="text-center text-red-500 font-semibold mb-4">{error}</p>}
//                 {renderOrderDetails()}
//             </div>
//         </div>
//     );
// };

// export default OrderConfirmation;

import React, { useState, useEffect, useRef } from 'react';
import apiCall from '../helper/apiCall';
import { toast } from 'react-toastify';
import { FiSearch, FiPrinter, FiTruck, FiCheck, FiX, FiFileText, FiUser, FiMapPin } from 'react-icons/fi';
import Spinner from './Spinner'; 
import ShipmentModal from './ShipmentModal';
import CancellationModal from './CancellationModal';
import usePrint from './usePrint';
import ShippingLabel from './ShippingLabel';
import ImageCarouselModal from './ImageCarouselModal';
import logo from '../assets/logo2.jpg';
import OrderInvoice from './OrderInvoice';

const OrderConfirmation = () => {
    const BASE_URL = "https://www.kanthasri.com";
    const [orderNumber, setOrderNumber] = useState('');
    const [orderData, setOrderData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [accepting, setAccepting] = useState({});
    const [error, setError] = useState(null);
    
    // Modal states
    const [showShipmentModal, setShowShipmentModal] = useState(false);
    const [selectedShipment, setSelectedShipment] = useState(null);
    const [showCancellationModal, setShowCancellationModal] = useState(false);
    const [itemToReject, setItemToReject] = useState(null);
    const [shippingLabelInfo, setShippingLabelInfo] = useState(null);
    const [showCarousel, setShowCarousel] = useState(false);
    const [carouselImages, setCarouselImages] = useState([]);

    const inputRef = useRef(null);
    const labelRef = useRef(null);
    const invoiceRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) inputRef.current.focus();
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSearch();
    };

    const handlePrintInvoiceTrigger = usePrint(invoiceRef, 'Order Invoice');
    const handlePrintLabelTrigger = usePrint(labelRef, 'Shipping Label');

    const handlePrintInvoice = () => {
        if (!orderData) return;
        setTimeout(() => handlePrintInvoiceTrigger(), 150);
    };

    const handleGenerateLabel = (shipmentId) => {
        const shipment = orderData.shipments.find(s => s.shipment_id === shipmentId);
        setShippingLabelInfo(shipment);
        setTimeout(() => handlePrintLabelTrigger(), 150);
    };

    const handleSearch = async () => {
        if (!orderNumber) {
            setError('Please enter an order number.');
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await apiCall("getOrderDetail", { order_number: orderNumber });
            if (response.success) setOrderData(response.data);
            else setError(response.message);
        } catch (err) {
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleAccept = async (orderItemId, oNum) => {
        if (!window.confirm("Confirm acceptance for fulfillment?")) return;
        setAccepting(prev => ({ ...prev, [orderItemId]: true }));
        try {
            const response = await apiCall("acceptOrderItem", { order_item_id: orderItemId, order_number: oNum });
            if (response.success) {
                toast.success('Item accepted.');
                handleSearch();
            } else toast.error(response.message);
        } catch (err) {
            toast.error('Processing failed.');
        } finally {
            setAccepting(prev => ({ ...prev, [orderItemId]: false }));
        }
    };

    const renderOrderDetails = () => {
        if (!orderData) return null;

        return (
            <div className="space-y-8 animate-in fade-in duration-500">
                {/* 1. Header & Summary Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    <div className="lg:col-span-2 bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
                        <div className="px-6 py-4 border-b border-slate-100 bg-slate-50/50 flex justify-between items-center">
                            <h2 className="text-sm font-bold text-slate-700 uppercase tracking-wider flex items-center gap-2">
                                <FiFileText className="text-blue-600" /> Order Summary
                            </h2>
                            <button
                                onClick={handlePrintInvoice}
                                className="inline-flex items-center gap-2 px-3 py-1.5 bg-slate-900 text-white text-xs font-semibold rounded-lg hover:bg-black transition-all"
                            >
                                <FiPrinter /> Print Invoice
                            </button>
                        </div>
                        <div className="p-6 grid grid-cols-2 gap-4">
                            <div>
                                <label className="text-[10px] font-bold text-slate-400 uppercase">Order ID</label>
                                <p className="text-sm font-bold text-slate-900">{orderData.order_number}</p>
                            </div>
                            <div>
                                <label className="text-[10px] font-bold text-slate-400 uppercase">Date</label>
                                <p className="text-sm text-slate-700">{new Date(orderData.order_date).toLocaleDateString()}</p>
                            </div>
                            <div>
                                <label className="text-[10px] font-bold text-slate-400 uppercase">Payment Method</label>
                                <p className="text-sm text-slate-700">{orderData.payment_method_name}</p>
                            </div>
                            <div>
                                <label className="text-[10px] font-bold text-slate-400 uppercase">Total Value</label>
                                <p className="text-lg font-black text-blue-600">{orderData.final_amount_INR}</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
                        <div className="px-6 py-4 border-b border-slate-100 bg-slate-50/50">
                            <h2 className="text-sm font-bold text-slate-700 uppercase tracking-wider flex items-center gap-2">
                                <FiMapPin className="text-emerald-600" /> Shipping To
                            </h2>
                        </div>
                        <div className="p-6">
                            <p className="font-bold text-slate-900 text-sm">{orderData.shippingAddress.shipping_full_name}</p>
                            <p className="text-xs text-slate-500 mt-1 leading-relaxed">
                                {orderData.shippingAddress.shipping_address_line1}, {orderData.shippingAddress.shipping_address_line2}<br />
                                {orderData.shippingAddress.shipping_city}, {orderData.shippingAddress.shipping_state_name} - {orderData.shippingAddress.shipping_pincode}
                            </p>
                            <div className="mt-3 inline-flex items-center gap-2 text-xs font-semibold text-slate-700 bg-slate-100 px-2 py-1 rounded">
                                <FiUser size={12}/> {orderData.shippingAddress.shipping_mobile_no}
                            </div>
                        </div>
                    </div>
                </div>

                {/* 2. Shipments Section */}
                <div className="space-y-6">
                    <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                        <FiTruck /> Shipments & Items
                    </h3>
                    {orderData.shipments.map((shipment) => (
                        <div key={shipment.shipment_id} className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                            <div className="p-4 bg-slate-50 border-b border-slate-200 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                                <div>
                                    <span className="text-[10px] font-black text-blue-500 uppercase">Shipment ID</span>
                                    <h4 className="font-bold text-slate-900">#{shipment.shipment_id}</h4>
                                    <p className="text-xs text-slate-500 font-medium">{shipment.shipping_status_description}</p>
                                </div>
                                <div className="flex gap-2">
                                    <button
                                        onClick={() => { setSelectedShipment(shipment); setShowShipmentModal(true); }}
                                        disabled={!shipment.shipment_enabled}
                                        className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 text-slate-700 text-xs font-bold rounded-lg hover:bg-slate-50 disabled:opacity-50 transition-all shadow-sm"
                                    >
                                        Update Logistics
                                    </button>
                                    <button
                                        onClick={() => handleGenerateLabel(shipment.shipment_id)}
                                        className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white text-xs font-bold rounded-lg hover:bg-indigo-700 transition-all shadow-md shadow-indigo-100"
                                    >
                                        <FiPrinter /> Label
                                    </button>
                                </div>
                            </div>

                            <div className="overflow-x-auto">
                                <table className="w-full text-left">
                                    <thead className="bg-slate-50/50 border-b border-slate-100">
                                        <tr className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                                            <th className="px-6 py-3">Item Detail</th>
                                            <th className="px-6 py-3">Order Qty</th>
                                            <th className="px-6 py-3">In Stock</th>
                                            <th className="px-6 py-3">Price</th>
                                            <th className="px-6 py-3 text-right">Fulfillment</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-50">
                                        {shipment.items.map((item) => (
                                            <tr key={item.order_item_id} className="hover:bg-slate-50/50 transition-colors">
                                                <td className="px-6 py-4 flex items-center gap-4">
                                                    <img 
                                                        src={`${BASE_URL}${item.product_item_images[0]?.grid}`} 
                                                        alt="prod" 
                                                        className="w-12 h-12 rounded-lg object-cover bg-slate-100 border border-slate-200 cursor-pointer"
                                                        onClick={() => {
                                                            setCarouselImages(item.product_item_images.map(i => `${BASE_URL}${i.main}`));
                                                            setShowCarousel(true);
                                                        }}
                                                    />
                                                    <div>
                                                        <div className="text-sm font-bold text-slate-900 line-clamp-1">{item.product_name}</div>
                                                        <div className="text-[11px] text-slate-500 font-medium">
                                                            {item.color_name} • {item.size_name}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 text-sm font-bold text-slate-700">{item.quantity}</td>
                                                <td className="px-6 py-4">
                                                    <span className={`text-xs font-bold ${item.product_item_stock_qty > 0 ? 'text-emerald-600' : 'text-red-500'}`}>
                                                        {item.product_item_stock_qty} available
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 text-sm font-medium text-slate-600">{item.final_amount_INR}</td>
                                                <td className="px-6 py-4 text-right">
                                                    <div className="flex justify-end gap-2">
                                                        <button
                                                            onClick={() => handleAccept(item.order_item_id, item.order_number)}
                                                            disabled={accepting[item.order_item_id] || item.order_item_status_id === 2}
                                                            className={`p-2 rounded-lg transition-all ${
                                                                item.order_item_status_id === 2 
                                                                ? 'bg-emerald-50 text-emerald-600' 
                                                                : 'bg-blue-50 text-blue-600 hover:bg-blue-600 hover:text-white shadow-sm'
                                                            }`}
                                                            title="Accept Item"
                                                        >
                                                            {accepting[item.order_item_id] ? <Spinner size="sm" /> : <FiCheck size={18} />}
                                                        </button>
                                                        <button
                                                            onClick={() => { setItemToReject(item.order_item_id); setShowCancellationModal(true); }}
                                                            disabled={item.cancelled}
                                                            className="p-2 bg-red-50 text-red-500 rounded-lg hover:bg-red-500 hover:text-white transition-all shadow-sm"
                                                            title="Reject Item"
                                                        >
                                                            <FiX size={18} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className="min-h-screen bg-[#fcfcfd] p-4 md:p-8">
            <div className="max-w-6xl mx-auto">
                {/* Search Header */}
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 mb-8">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                        <div>
                            <h1 className="text-xl font-black text-slate-900">Order Management</h1>
                            <p className="text-xs text-slate-500 font-medium">Process orders, generate labels, and manage shipments.</p>
                        </div>
                        <div className="flex w-full md:w-auto gap-2">
                            <div className="relative flex-grow md:w-80">
                                <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                                <input
                                    ref={inputRef}
                                    type="text"
                                    placeholder="Scan Barcode or Type Order #"
                                    value={orderNumber}
                                    onChange={(e) => setOrderNumber(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                    className="w-full pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all outline-none font-medium text-sm"
                                />
                            </div>
                            <button
                                onClick={handleSearch}
                                disabled={loading}
                                className="px-6 py-2.5 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 shadow-lg shadow-blue-200 transition-all disabled:opacity-50"
                            >
                                {loading ? 'Searching...' : 'Retrieve'}
                            </button>
                        </div>
                    </div>
                    {error && <div className="mt-4 p-3 bg-red-50 text-red-600 text-xs font-bold rounded-lg border border-red-100">{error}</div>}
                </div>

                {renderOrderDetails()}
            </div>

            {/* Modals & Hidden Print Elements */}
            <ImageCarouselModal show={showCarousel} onClose={() => setShowCarousel(false)} images={carouselImages} />
            <ShipmentModal showModal={showShipmentModal} onClose={() => setShowShipmentModal(false)} onUpdate={handleSearch} shipmentData={selectedShipment} />
            <CancellationModal showModal={showCancellationModal} onClose={() => setShowCancellationModal(false)} onConfirm={() => { setShowCancellationModal(false); handleSearch(); }} orderItemId={itemToReject} orderData={orderData} />
            
            <div style={{ display: 'none' }}>
                {shippingLabelInfo && <ShippingLabel ref={labelRef} orderDetail={shippingLabelInfo.orderDetail} shippingDetail={shippingLabelInfo.shippingDetail} />}
                {orderData && <OrderInvoice ref={invoiceRef} orderData={orderData} logo={logo} />}
            </div>
        </div>
    );
};

export default OrderConfirmation;